import { Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { Box, FlexColBox } from "../../../common/components";
import { spacing } from "../../../styles/theme";
import { ComboItems, ItemPricing } from "../../../types";
import CartItemPrice from "../Components/CartItemPrice";
import { useThemeBreakpoints } from "../../../utils/themeUtils";

interface Props {
  deprecatedDesign: boolean;
  item: ItemPricing;
  comboItems: ComboItems;
  isBundle: boolean;
}

const CartItemNameAndPrice = ({ item, comboItems, isBundle }: Props) => {
  const { t } = useTranslation();
  const { isMobile } = useThemeBreakpoints();

  const shouldHidePrice = isMobile && isBundle;

  return (
    <Box
      display={"flex"}
      flexDirection={{ xs: "column", lg: "row" }}
      gap={{ xs: spacing.subtitleMobile, lg: "24px" }}
      alignItems="flex-start"
      maxWidth="100%"
      overflow="hidden"
    >
      <FlexColBox
        gap={"8px"}
        flexGrow={1}
        maxWidth={{
          xs: "100%",
          lg: `calc(100% - 24px - 45px)`,
        }}
      >
        <Typography
          data-test={item.designName}
          variant="h2"
          flexGrow={1}
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {item.designName || t("design.untitled_design")}
        </Typography>
      </FlexColBox>
      {!shouldHidePrice && (
        <CartItemPrice comboItems={comboItems} item={item} />
      )}
    </Box>
  );
};

export default memo(CartItemNameAndPrice);
